import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { OrganisationTypeConstants } from "../../../../constants";
import { TabsList } from "../../../../models";
import { IStateOrigin } from "../../../../navigators/navigateStateObjects";
import { GetProjectDetailsResponse } from "../../../../service/query";
import {
  getProjectActivityReviewRoute,
  getProjectDetailsByUuid,
  getProjectDocumentsRoute,
  getProjectInventoryRoute,
  getProjectsRoute,
} from "../../../../utils/routes";
import { ProjectContext } from "../../../shared/projects/project/ProjectContext";

interface UseProjectReturnData {
  projectDetails: GetProjectDetailsResponse | undefined;
  backButtonText: string;
  handleBackClick: () => void;
  tabsList: TabsList;
}

export const useProject = (): UseProjectReturnData => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const stateOrigin = state?.origin as IStateOrigin;
  const { projectDetails } = useContext(ProjectContext);

  const backButtonText = stateOrigin?.goBackText ?? "Back to projects";

  const handleBackClick = (): void => {
    if (stateOrigin?.from) navigate(stateOrigin?.from);
    else navigate(getProjectsRoute(OrganisationTypeConstants.VERIFIER));
  };

  const getTabsList = (): TabsList => {
    const list = [
      {
        label: "Overview",
        route: getProjectDetailsByUuid(projectDetails?.uuid || "", OrganisationTypeConstants.VERIFIER),
      },
      {
        label: "Inventory",
        route: getProjectInventoryRoute(projectDetails?.uuid || "", OrganisationTypeConstants.VERIFIER),
      },
      {
        label: "Documents",
        route: getProjectDocumentsRoute(projectDetails?.uuid || "", OrganisationTypeConstants.VERIFIER),
      },
      {
        label: "Reviews",
        route: getProjectActivityReviewRoute(projectDetails?.uuid || "", OrganisationTypeConstants.VERIFIER),
      },
    ];

    return list;
  };

  return {
    projectDetails,
    backButtonText,
    handleBackClick,
    tabsList: getTabsList(),
  };
};
